import React from "react";
import { Box, Typography } from "@mui/material";

const VideoListheader = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          background: "#fff",
          color: "#fff",
          height: "45px",
          width: "1900px",
        }}
      >
        <Typography
          sx={{
            width: "70px",
            display: "flex",
            color: "#fff",
            alignItems: "center",
            justifyContent: "center",
            borderLeft: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            height: 44,
            background: "#A10303",
          }}
        >
          No
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Name
        </Typography>
        <Typography
          sx={{
            width: "400px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Link
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Course
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          Chapter
        </Typography>
        <Typography
          sx={{
            width: "180px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          User
        </Typography>
        <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#A10303",
          }}
        >
          CreatedAt
        </Typography>
        {/* <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#004A99",
          }}
        >
          ရက်စွဲ 
        </Typography> */}
        <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            color: "#fff",
            background: "#A10303",
            height: 44,
            justifyContent: "center",
          }}
        >
          UpdatedAt
        </Typography>
        <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            color: "#fff",
            background: "#A10303",
            height: 44,
            justifyContent: "center",
          }}
        >
          Action
        </Typography>
        {/* <Typography
          sx={{
            width: "150px",
            display: "flex",
            alignItems: "center",
            borderLeft: "1px solid #e0e0ef",
            borderRight: "1px solid #e0e0ef",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            color: "#fff",
            background: "#A10303",
            height: 44,
            justifyContent: "center",
          }}
        >
          Detail
        </Typography> */}
      </Box>
    </>
  );
};

export default VideoListheader;
